<template>
  <div>
    <div id="map" style="height: 100vh;"></div>
    <v-card class="top_map">
      <v-autocomplete
      v-model="searchmodel"
      :items="datas"
      chips
      clearable
      hide-details
      hide-selected
      item-text="name"
      label="门店位置查询"
      solo
      @change="searchChange"
      ></v-autocomplete>
    </v-card>
    <v-card class="bot_map" :class="botclass" @click="drawer=!drawer">
      <span class="flag1"><span>农药门店:</span><span>{{flag1len}}家</span></span>
      <span class="flag2"><span>兽药门店:</span><span>{{flag2len}}家</span></span>
      <span class="flag3"><span>饲料生产企业:</span><span>{{flag3len}}家</span></span>
    </v-card>
    <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
      right
      :width="320"
    >
      <v-expansion-panels accordion>
        <v-expansion-panel v-for="(item,index) in datas" :key="index">
          <v-expansion-panel-header :style="{color:item.flag==1?'#F44336':(item.flag==2?'#3F51B5':'#9C27B0')}">{{ item.name }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <div>法人:{{item.faren}}</div>
            <div>电话:{{item.phone}}</div>
            <div>证号:{{item.code}}</div>
            <div>地址:{{item.addr}}</div>
            <div style="text-align: right;">
              <v-btn color="primary" @click="tozb(item)">定位</v-btn>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-navigation-drawer>
    <div id="popup" class="ol-popup">
      <a href="#" id="popup-closer" class="ol-popup-closer"></a>
      <div id="popup-content"></div>
    </div>
  </div>
</template>
<script>
import 'ol/ol.css';

import { Map, View, Feature } from "ol";
import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';

import Point from "ol/geom/Point";
import VectorSource from "ol/source/Vector";
import Cluster from "ol/source/Cluster";
import VectorLayer from "ol/layer/Vector";

import Overlay from 'ol/Overlay';

import {
  Circle as CircleStyle,
  Fill,
  Text,
  Stroke,
  Style,
} from "ol/style";

export default {
  data() {
    return {
      map: null,
      mapView: null,
      datas: [
        {name:'无棣县铭鑫农资批发部',zb:[117.718,37.783],code:'农药经许（鲁）37162320001',faren:'邓明鑫',phone:'13561503928',addr:'山东省无棣县水湾镇关家庄村122号',flag:1},
        {name:'无棣县艳辉农资营销经营部',zb:[117.674,37.781],code:'农药经许（鲁）37162320002',faren:'邓明辉',phone:'15065233118',addr:'无棣县水湾镇关家庄村122号',flag:1},
        {name:'无棣县益农农资综合经营部',zb:[117.702,37.821],code:'农药经许（鲁）37162320007',faren:'李刚',phone:'13475050108',addr:'无棣县水湾镇龙湾一路北侧',flag:1},
        {name:'无棣县水湾镇黑马种业',zb:[117.699,37.817],code:'农药经许（鲁）37162320018',faren:'王俊果',phone:'13581155887',addr:'无棣县水湾镇龙腾二路镇府沿街楼1号',flag:1},
        {name:'无棣县刘军农资服务部',zb:[117.717,37.784],code:'农药经许（鲁）37162320072',faren:'刘金军',phone:'15205875355',addr:'无棣县水湾镇庞家集村',flag:1},
        {name:'无棣县海新农资服务中心',zb:[117.680,37.793],code:'农药经许（鲁）37162320079',faren:'孙海新',phone:'13506373979',addr:'无棣县水湾镇小米河高家村',flag:1},
        {name:'无棣县民之友农资经营部',zb:[117.722,37.766],code:'农药经许（鲁）37162320080',faren:'李国华',phone:'13561513578',addr:'无棣县水湾镇西吴家庙村',flag:1},
        {name:'无棣县同云农资经营部',zb:[117.760,37.790],code:'农药经许（鲁）37162320081',faren:'郑同云',phone:'15954323211',addr:'无棣县水湾镇张建屯村',flag:1},
        {name:'无棣县曹秀文农资经营部',zb:[117.729,37.823],code:'农药经许（鲁）37162320082',faren:'曹秀文',phone:'15266702318',addr:'无棣县水湾镇周家村',flag:1},
        {name:'无棣县水湾镇枣树庄稼医院',zb:[117.704,37.818],code:'农药经许（鲁）37162320083',faren:'王丕合',phone:'13589723835',addr:'无棣县水湾镇蔡河路东侧',flag:1},
        {name:'无棣县俊峰农资超市',zb:[117.714,37.857],code:'农药经许（鲁）37162320084',faren:'步乃峰',phone:'15066993328',addr:'无棣县水湾镇路庙村',flag:1},
        {name:'无棣县水湾镇老马种子化肥经营部',zb:[117.700,37.820],code:'农药经许（鲁）37000010041',faren:'马志杰',phone:'18763057881',addr:'无棣县水湾镇龙腾二路西侧',flag:1},
        {name:'无棣县诺农农资批发',zb:[117.762,37.789],code:'农药经许（鲁）37162320094',faren:'刘红军',phone:'18054349123',addr:'无棣县水湾镇张建屯村',flag:1},
        {name:'无棣县佘家镇宝强农业科技站',zb:[117.807,37.750],code:'农药经许（鲁）37162320003',faren:'吴宝强',phone:'13675439006',addr:'无棣县佘家镇南邓村',flag:1},
        {name:'无棣县李喜峰农资服务中心',zb:[117.717,37784],code:'农药经许（鲁）37162320100',faren:'李喜峰',phone:'13589423913',addr:'无棣县水湾镇庞集村',flag:1},
        {name:'无棣县明亮农资服务部',zb:[117.783,37.799],code:'农药经许（鲁）37162320067',faren:'崔明亮',phone:'15865415191',addr:'无棣县水湾镇刘王庄村',flag:1},
        {name:'无棣县青艳农资经营部',zb:[117.773,37.814],code:'农药经许（鲁）37162320068',faren:'郭青艳',phone:'13854353528',addr:'无棣县水湾镇毛王庄村',flag:1},
        {name:'无棣县益民农资经营部',zb:[117.701,37.822],code:'农药经许（鲁）37162320101',faren:'程风平',phone:'18706438166',addr:'无棣县水湾镇水湾村',flag:1},
        {name:'无棣县春雷农资经营部',zb:[117.716,37.855],code:'农药经许（鲁）37162320131',faren:'步爱华',phone:'15550298576',addr:'山东省滨州市无棣县水湾镇逯庙村村东',flag:1},
        {name:'无棣县水湾镇建峰种子化肥经营部',zb:[117.700,37.821],code:'农药经许（鲁）37162320112',faren:'王玉花',phone:'13581155238',addr:'无棣县水湾镇龙腾二路东侧',flag:1},
        {name:'无棣县昊杨农资经营部',zb:[117.770,37.812],code:'农药经许（鲁）37162320076',faren:'毛金明',phone:'18364917934',addr:'无棣县水湾镇毛王庄村',flag:1},
        {name:'无棣县宝富农资服务部',zb:[117.669,37.786],code:'农药经许（鲁）37162320096',faren:'王宝富',phone:'15066934117',addr:'山东省滨州市无棣县水湾镇贺家庄村',flag:1},
        {name:'无棣县佘家镇方民农资经营部',zb:[117.809,37.825],code:'农药经许（鲁）37162320004',faren:'方自敬',phone:'15854383268',addr:'无棣县佘家镇马家仓村60号',flag:1},
        {name:'无棣县佘家黑马种业',zb:[117.849,37.812],code:'农药经许（鲁）37162320005',faren:'杨金国',phone:'13954363127',addr:'无棣县佘家巷乡政府驻地',flag:1},
        {name:'无棣县佘家镇新果农资批发',zb:[117.845,37.754],code:'农药经许（鲁）37162320006',faren:'陈玉果',phone:'13589413630',addr:'无棣县佘家镇西栾村',flag:1},
        {name:'无棣县佘家镇正牌农资综合服务中心',zb:[117.852,37.812],code:'农药经许（鲁）37162320008',faren:'张云涛',phone:'13173291627',addr:'无棣县佘家镇政府驻地',flag:1},
        {name:'无棣瑞丰源种业有限责任公司',zb:[117.842,37.793],code:'农药经许（鲁）37162320020',faren:'王宝军',phone:'13793883028',addr:'无棣县佘家镇',flag:1},
        {name:'无棣县佘家镇俊忠农资经营部',zb:[117.848,37.813],code:'农药经许（鲁）37162320017',faren:'王俊忠',phone:'13561593128',addr:'无棣县佘家镇门市部',flag:1},
        {name:'无棣县佘家镇志华农资经营部',zb:[117.888,37.818],code:'农药经许（鲁）37162320011',faren:'刘志华',phone:'13581155718',addr:'无棣县佘家镇石庙南村',flag:1},
        {name:'无棣县佘家镇张凡大地农资超市',zb:[117.809,37.755],code:'农药经许（鲁）37162320024',faren:'张凡',phone:'13561573858',addr:'无棣县佘家镇东北邓村',flag:1},
        {name:'无棣县佘家镇信用于民农资综合门市部',zb:[117.853,37.813],code:'农药经许（鲁）37162320025',faren:'郭士信',phone:'15954313958',addr:'无棣县佘家镇政府驻地',flag:1},
        {name:'无棣县佘家镇健民农资经营部',zb:[117.825,37.751],code:'农药经许（鲁）37162320026',faren:'范建民',phone:'15898898430',addr:'无棣县佘家镇皂户张村',flag:1},
        {name:'无棣县佘家镇云保农资经营部门市部',zb:[117.810,37.826],code:'农药经许（鲁）37162320027',faren:'马云保',phone:'13685433968',addr:'无棣县佘家镇马家仓村',flag:1},
        {name:'无棣县佘家镇金清农资门市部',zb:[117.853,37.813],code:'农药经许（鲁）37162320064',faren:'王金清',phone:'13561580309',addr:'无棣县佘家镇政府驻地',flag:1},
        {name:'无棣县佘家镇同岭农资服务部',zb:[117.794,37.747],code:'农药经许（鲁）37162320097',faren:'邢同岭',phone:'15969981582',addr:'无棣县佘家镇邢家村',flag:1},
        {name:'无棣七星种植专业合作社',zb:[117.791,37.740],code:'农药经许（鲁）37162320106',faren:'赵立德',phone:'15550621768',addr:'无棣县佘家镇赵家磨徐村',flag:1},
        {name:'无棣县佘家镇希民农资门市部',zb:[117.827,37.745],code:'农药经许（鲁）37162320093',faren:'王希民',phone:'15966376386',addr:'山东省滨州市无棣县佘家镇栗家村',flag:1},
        {name:'无棣县佘家镇胜凯农资经营部',zb:[117.825,37.787],code:'农药经许（鲁）37162320139',faren:'曾庆申',phone:'13475099408',addr:'山东省滨州市无棣县佘家镇曾家庄',flag:1},
        {name:'无棣县西小王镇宝忠农资经营部',zb:[117.811,37.862],code:'农药经许（鲁）37162320009',faren:'崔宝忠',phone:'13061038051',addr:'西小王大街',flag:1},
        {name:'无棣县振瀚农资有限公司',zb:[117.942,37.881],code:'农药经许（鲁）37162320010',faren:'姬风丽',phone:'13589718255',addr:'无棣县西小王镇林场1号',flag:1},
        {name:'无棣县西小王镇志勇农资综合经营部',zb:[117.888,37.884],code:'农药经许（鲁）37162320021',faren:'刘志勇',phone:'15866654992',addr:'山东省滨州市无棣县西小王镇关庄子村',flag:1},
        {name:'无棣县李玮农资经营部',zb:[117.619,37.827],code:'农药经许（鲁）37162320012',faren:'李玮',phone:'13561593228',addr:'无棣县信阳镇店子村',flag:1},
        {name:'无棣县西小王镇春祥化肥门市部',zb:[117.843,37.877],code:'农药经许（鲁）37162320022',faren:'方春祥',phone:'13356291766',addr:'无棣县西小王镇小屯河北村',flag:1},
        {name:'无棣县西小王镇洪强农资门市部',zb:[117.842,37.878],code:'农药经许（鲁）37162320023',faren:'杨洪强',phone:'13589703658',addr:'无棣县西小王镇小屯河北村',flag:1},
        {name:'无棣利丰农资有限公司',zb:[117.806,37.819],code:'农药经许（鲁）37162320057',faren:'关冬林',phone:'13792264099',addr:'西小王镇省道320与省道237交叉口南200米路西',flag:1},
        {name:'无棣县西小王镇富民源农资批发门市部',zb:[117.810,37.866],code:'农药经许（鲁）37162320091',faren:'曹林庆',phone:'13326291199',addr:'无棣县西小王镇曹家村',flag:1},
        {name:'无棣县西小王镇老百姓农资经营部',zb:[117.806,37.856],code:'农药经许（鲁）37162320110',faren:'程树龙',phone:'15376275368',addr:'无棣县西小王镇政府驻地（西小王村）',flag:1},
        {name:'无棣县西小王镇宝洪农资服务中心',zb:[117.810,37.860],code:'农药经许（鲁）37000010205',faren:'杨金霞',phone:'13396499198',addr:'无棣县西小王镇政府驻地',flag:1},
        {name:'无棣县西小王镇民丰农资批发',zb:[117.808,37.855],code:'农药经许（鲁）37162320132',faren:'蒋荣贤',phone:'13605033323',addr:'山东省滨州市无棣县西小王镇西小王村',flag:1},
        {name:'无棣县西小王镇王小平农资经营门市部',zb:[117.809,37.853],code:'农药经许（鲁）37162320129',faren:'王小平',phone:'15563012678',addr:'山东省滨州市无棣县西小王镇政府驻地（西小王村）',flag:1},
        {name:'无棣县西小王镇如山农资批发部',zb:[117.809,37.857],code:'农药经许（鲁）37162320118',faren:'王芳',phone:'13176299329',addr:'滨州市无棣县西小王镇政府驻地',flag:1},
        {name:'无棣县西小王镇景民农资经营部',zb:[117.846,37.874],code:'农药经许（鲁）37162320107',faren:'杨景民',phone:'15550244789',addr:'山东省滨州市无棣县西小王镇小屯河南村',flag:1},
        {name:'宝民农资门市部',zb:[117.788,37.855],code:'农药经许（鲁）37162320058',faren:'张宝民',phone:'13589735281',addr:'西小王镇张岔河村',flag:1},
        {name:'无棣县柳堡镇占征化肥种子经营部',zb:[117.814,37.944],code:'农药经许（鲁）37162320013',faren:'王占贞',phone:'13061037969',addr:'无棣县柳堡镇常南村',flag:1},
        {name:'无棣县华龙农业生产资料有限公司',zb:[117.815,37.943],code:'农药经许（鲁）37162320014',faren:'杨超',phone:'13355435387',addr:'无棣县柳堡乡常家村南',flag:1},
        {name:'无棣县柳堡镇祥龙农资综合经营部',zb:[117.838,37.915],code:'农药经许（鲁）37162320019',faren:'张永祥',phone:'13396284789',addr:'无棣县柳堡镇付圈张家村',flag:1},
        {name:'无棣县柳堡镇诚营农资综合服务中心',zb:[117.736,37.953],code:'农药经许（鲁）37162320028',faren:'李祥诚',phone:'13455773376',addr:'无棣县柳堡镇李柳村',flag:1},
        {name:'无棣县柳堡镇老吴农资批发部',zb:[117.779,37.945],code:'农药经许（鲁）37162320029',faren:'吴凤霞',phone:'18454394868',addr:'无棣县柳堡镇杨姑娘村',flag:1},
        {name:'无棣县柳堡镇自强农资服务中心',zb:[117.904,37.961],code:'农药经许（鲁）37162320035',faren:'李泽明',phone:'15254380597',addr:'无棣县柳堡镇杨庄子村',flag:1},
        {name:'柳堡镇本滨农资经销部',zb:[117.793,37.900],code:'农药经许（鲁）37162320078',faren:'吴本滨',phone:'18954339844',addr:'无棣县柳堡镇岳里村',flag:1},
        {name:'无棣县柳堡镇庆晖农资综合门市',zb:[117.896,37.924],code:'农药经许（鲁）37162320117',faren:'谭聪聪',phone:'13563073194',addr:'滨州市无棣县柳堡镇谭庄子村',flag:1},
        {name:'无棣县柳堡镇硕毓农资综合门市部',zb:[117.841,37.917],code:'农药经许（鲁）37162320065',faren:'张寿新',phone:'15054313234',addr:'无棣县柳堡镇傅瞿阝张家村',flag:1},
        {name:'无棣县柳堡镇树建种子门市部',zb:[117.726,37.957],code:'农药经许（鲁）37162320124',faren:'王树建',phone:'15065435876',addr:'无棣县柳堡镇大王柳村',flag:1},
        {name:'无棣县柳堡镇景行农资综合服务部',zb:[117.794,37.902],code:'农药经许（鲁）37162320103',faren:'孙景行',phone:'15169928372',addr:'山东省滨州市无棣县柳堡镇西岳里村',flag:1},
        {name:'无棣县柳堡镇支农农资销售店',zb:[117.850,37.930],code:'农药经许（鲁）37162320108',faren:'孙金榜',phone:'15254396989',addr:'山东省滨州市无棣县柳堡镇孙家圈村',flag:1},
        {name:'无棣县柳堡镇殿芹农资综合经营部',zb:[117.839,37.916],code:'农药经许（鲁）37162320066',faren:'张勇胜',phone:'15054313234',addr:'无棣县柳堡镇傅瞿阝张家村',flag:1},
        {name:'无棣县柳堡镇广收农资经营部',zb:[117.814,37.944],code:'农药经许（鲁）37162320105',faren:'王俊明',phone:'13475050359',addr:'山东省滨州市柳堡镇常家南村',flag:1},
        {name:'无棣县柳堡镇鸿翔农资销售部',zb:[117.843,37.912],code:'农药经许（鲁）37162320109',faren:'王换生',phone:'17854394281',addr:'山东省滨州市无棣县柳堡镇傅O苏家村',flag:1},
        {name:'无棣县柳堡镇希来农资门市部',zb:[117.796,37.903],code:'农药经许（鲁）37162320075',faren:'朱希来',phone:'13589700670',addr:'无棣县西岳里村',flag:1},
        {name:'无棣县柳堡镇青耘农资经营部',zb:[117.747,37.972],code:'农药经许（鲁）37162320098',faren:'杜青耘',phone:'15006978961',addr:'山东省滨州市无棣县柳堡镇政府驻地',flag:1},
        {name:'无棣县吴文广农资经营部',zb:[117.609,37.795],code:'农药经许（鲁）37162320015',faren:'吴文广',phone:'13455773479',addr:'无棣县信阳镇吴店村',flag:1},
        {name:'无棣惠农种子科技有限公司',zb:[117.616,37.815],code:'农药经许（鲁）37162320095',faren:'张余芬',phone:'13465432131',addr:'无棣县信阳镇郭来仪村东',flag:1},
        {name:'无棣县玉路农资经营部',zb:[117.625,37.827],code:'农药经许（鲁）37162320111',faren:'郭玉路',phone:'13506374186',addr:'无棣县信阳镇西粉村',flag:1},
        {name:'无棣县农资供应有限公司信阳分公司',zb:[117.620,37.826],code:'农药经许（鲁）37162320137',faren:'吴宝云',phone:'13589723811',addr:'无棣县信阳店子',flag:1},
        {name:'无棣县富东农资经营门市部',zb:[117.582,37.816],code:'农药经许（鲁）37162320130',faren:'邢富东',phone:'13561583663',addr:'无棣县信阳镇大庄东村',flag:1},
        {name:'无棣县辰杭农业科技有限公司',zb:[117.622,37.821],code:'农药经许（鲁）37162320115',faren:'王立峰',phone:'15169900277',addr:'无棣县信阳镇店子桥南阳光车队18号',flag:1},
        {name:'无棣县阳信镇宝田农资经营部',zb:[117.631,37.807],code:'农药经许（鲁）37162320016',faren:'李月云',phone:'13505433648',addr:'无棣县阳信镇车里东村',flag:1},
        {name:'无棣县富永农资经营部',zb:[117.602,37.837],code:'农药经许（鲁）37162320077',faren:'赵富永',phone:'15376773866',addr:'无棣县阳信双堠村',flag:1},
        {name:'无棣县车王镇金广农资经营部',zb:[117.640,37.877],code:'农药经许（鲁）37162320030',faren:'张金广',phone:'13181025801',addr:'车王镇七路',flag:1},
        {name:'无棣县博丰种子经营部',zb:[117.681,37.939],code:'农药经许（鲁）37162320031',faren:'崔龙江',phone:'13854393768',addr:'无棣县车王镇崔什东村',flag:1},
        {name:'无棣县王洪双化肥经营部',zb:[117.639,37.883],code:'农药经许（鲁）37162320032',faren:'王洪双',phone:'13563093151',addr:'无棣县车王镇车镇南村',flag:1},
        {name:'无棣县李进种子经营部',zb:[117.640,37.882],code:'农药经许（鲁）37162320033',faren:'李厚刚',phone:'13793883885',addr:'无棣县车王镇车镇南村',flag:1},
        {name:'无棣县张涛农资经营部',zb:[117.629,37.905],code:'农药经许（鲁）37162320034',faren:'张海涛',phone:'15054313234',addr:'无棣县车王镇大张邢王王村',flag:1},
        {name:'无棣县宗练种子化肥经营部',zb:[117.612,37.890],code:'农药经许（鲁）37162320128',faren:'赵宗练',phone:'15376773866',addr:'无棣县车王镇五道庙村',flag:1},
        {name:'无棣县一龙农资经营部',zb:[117.633,37.905],code:'农药经许（鲁）37162320116',faren:'崔梅月',phone:'18755344304',addr:'无棣县车王镇杨家邢王村',flag:1},
        {name:'无棣县朱明月农资经营部',zb:[117.604,37.901],code:'农药经许（鲁）37162320138',faren:'朱明月',phone:'18764561599',addr:'无棣县车王镇朱家村',flag:1},
        {name:'无棣县洪章农资服务部',zb:[117.691,37.939],code:'农药经许（鲁）37162320071',faren:'李洪章',phone:'15066971927',addr:'无棣县车王镇李什村',flag:1},
        {name:'无棣县王树蕾农资经营部',zb:[117.645,37.941],code:'农药经许（鲁）37162320069',faren:'王树蕾',phone:'15854360540',addr:'无棣县车王镇大王庄村',flag:1},
        {name:'无棣县丰硕农资服务中心',zb:[117.711,38.018],code:'农药经许（鲁）37162320037',faren:'冯其荣',phone:'15054358181',addr:'无棣县碣石山镇大吴码头村西',flag:1},
        {name:'无棣县睿睿化肥种子经营站',zb:[117.686,38.015],code:'农药经许（鲁）37162320047',faren:'王金波',phone:'15154333817',addr:'无棣县碣石山镇大山东村',flag:1},
        {name:'无棣县和润农资服务中心',zb:[117.685,38.014],code:'农药经许（鲁）37162320062',faren:'孙文义',phone:'13181000039',addr:'碣石山镇大山东村海产市场大山东路61、63号',flag:1},
        {name:'无棣县忠銮农化服务中心',zb:[117.686,38.006],code:'农药经许（鲁）37162320073',faren:'乔忠銮',phone:'15865446311',addr:'无棣县碣石山镇商业街',flag:1},
        {name:'无棣县德环农资经营部',zb:[117.686,38.005],code:'农药经许（鲁）37162320061',faren:'顾德环',phone:'13906493709',addr:'无棣县碣石山镇',flag:1},
        {name:'无棣县正稼农资批发部',zb:[117.607,37.739],code:'农药经许（鲁）37162320040',faren:'王涛',phone:'15265435588',addr:'无棣县中心大街',flag:1},
        {name:'无棣县正浓农资批发部',zb:[117.615,37.740],code:'农药经许（鲁）37162320041',faren:'王新勇',phone:'18265438668',addr:'无棣县中心大街',flag:1},
        {name:'山东省无棣欣宇棉业有限公司无棣经营部',zb:[117.603,37.752],code:'农药经许（鲁）37162320045',faren:'邢爱民',phone:'13954303286',addr:'无棣县棣新一路15号',flag:1},
        {name:'无棣县俊銮农资经营部',zb:[117.624,37.740],code:'农药经许（鲁）37162320046',faren:'赵俊銮',phone:'13589733909',addr:'无棣县海丰九路十号',flag:1},
        {name:'无棣县杨同辉农资经营部',zb:[117.632,37.729],code:'农药经许（鲁）37162320044',faren:'杨同辉',phone:'13176290899',addr:'无棣县富路大街东首',flag:1},
        {name:'无棣县春秀农资门市部',zb:[117.628,37.730],code:'农药经许（鲁）37162320043',faren:'李幸福',phone:'18706438111',addr:'无棣县富路大街东首',flag:1},
        {name:'无棣县烽火化肥门市部',zb:[117.608,37.732],code:'农药经许（鲁）37162320042',faren:'李坤军',phone:'15969993797',addr:'无棣县富路大街',flag:1},
        {name:'无棣县老赵农资服务站',zb:[117.610,37.733],code:'农药经许（鲁）37162320048',faren:'蒋付香',phone:'13205430443',addr:'无棣县富路大街',flag:1},
        {name:'无棣县利成农资经营部',zb:[117.569,38.003],code:'农药经许（鲁）37162320049',faren:'郭庆叶',phone:'18265431598',addr:'无棣县小泊头镇乔家庄',flag:1},
        {name:'无棣县建岗农资经营部',zb:[117.599,38.055],code:'农药经许（鲁）37162320050',faren:'王景芳',phone:'15066971778',addr:'无棣县小泊头镇老泊头街驻地',flag:1},
        {name:'无棣县文岩农资经营部',zb:[117.580,38.017],code:'农药经许（鲁）37162320051',faren:'王洪玉',phone:'13793873456',addr:'无棣县泊头镇郭家',flag:1},
        {name:'无棣县晓辰农资门市部',zb:[117.566,38.043],code:'农药经许（鲁）37162320053',faren:'李景坤',phone:'13589413397',addr:'无棣县小泊头镇东村',flag:1},
        {name:'无棣县世豪农资超市',zb:[117.579,38.001],code:'农药经许（鲁）37162320054',faren:'杜福松',phone:'15805433112',addr:'无棣县小泊头镇杜家庄村',flag:1},
        {name:'无棣县广升化肥种子门市部',zb:[117.566,38.013],code:'农药经许（鲁）37162320126',faren:'王广升',phone:'15376773866',addr:'山东省滨州市无棣县小泊头镇前菜园村路口往北50米路东',flag:1},
        {name:'无棣县兆楼农资经营部',zb:[117.647,38.066],code:'农药经许（鲁）37162320074',faren:'贾兆楼',phone:'15066965644',addr:'无棣县小泊头镇贾家庄村',flag:1},
        {name:'滨州市和茂农资有限公司',zb:[117.573,38.056],code:'农药经许（鲁）37162320136',faren:'高金山',phone:'15169991888',addr:'无棣县小泊头镇北高家庄村',flag:1},
        {name:'无棣县德亮农资销售经营部',zb:[117.561,38.041],code:'农药经许（鲁）37162320133',faren:'仝德亮',phone:'13562313941',addr:'山东省滨州市无棣县小泊头镇第二小学对过',flag:1},
        {name:'无棣县振涛农资服务站',zb:[117.623,38.008],code:'农药经许（鲁）37162320123',faren:'孙成元',phone:'15954365137',addr:'无棣县小泊头镇孙马村',flag:1},
        {name:'无棣县凯泽农资服务站',zb:[117.625,38.010],code:'农药经许（鲁）37162320127',faren:'孙长利',phone:'13169942449',addr:'山东省滨州市无棣县小泊头镇孙马村',flag:1},
        {name:'无棣县程口镇思思农资门市部',zb:[117.728,38.101],code:'农药经许（鲁）37162320052',faren:'陈金刚',phone:'15065253915',addr:'无棣县程口镇西北村',flag:1},
        {name:'无棣县宝林农资门市部',zb:[117.733,38.039],code:'农药经许（鲁）37162320063',faren:'刘宝林',phone:'15965010092',addr:'无棣县程口镇宋王村',flag:1},
        {name:'无棣县从延农资销售部',zb:[117.731,38.038],code:'农药经许（鲁）37162320099',faren:'康树通',phone:'13854364557',addr:'无棣县埕口镇宋王村',flag:1},
        {name:'无棣县春栋农资经营部',zb:[117.618,37.723],code:'农药经许（鲁）37162320055',faren:'张春栋',phone:'13954313306',addr:'无棣县富路大街小马新村',flag:1},
        {name:'无棣新创农业科技有限公司',zb:[117.632,37.780],code:'农药经许（鲁）37162320056',faren:'崔海树',phone:'15169978815',addr:'无棣县棣丰街道小杨村',flag:1},
        {name:'无棣县利禾农资经营部',zb:[117.602,37.759],code:'农药经许（鲁）37162320039',faren:'刘梅春',phone:'13954393098',addr:'无棣县海丰街道杨三里村',flag:1},
        {name:'无棣农喜农资有限公司',zb:[117.601,37.759],code:'农药经许（鲁）37162320085',faren:'吴厚本',phone:'15376773866',addr:'无棣县海丰街道小陈家村',flag:1},
        {name:'无棣名九州农业有限公司',zb:[117.621,37.743],code:'农药经许（鲁）37162320086',faren:'林殿志',phone:'13188906291',addr:'无棣县海丰街道朱家庄村',flag:1},
        {name:'滨州市年年丰农资有限公司',zb:[117.594,37.747],code:'农药经许（鲁）37162320089',faren:'李向阳',phone:'13061033207',addr:'无棣县海丰街道于庙村',flag:1},
        {name:'无棣县徐鹏农资经营部',zb:[117.554,37.745],code:'农药经许（鲁）37162320121',faren:'徐鹏',phone:'13705433276',addr:'无棣县海丰街道付家村',flag:1},
        {name:'无棣县宅科化肥经营部',zb:[117.575,37.734],code:'农药经许（鲁）37162320120',faren:'孙金中',phone:'15554311668',addr:'无棣县海丰街道冯家村',flag:1},
        {name:'无棣县富展强农资有限公司',zb:[117.602,37.747],code:'农药经许（鲁）37162320113',faren:'孙玉强',phone:'13061030080',addr:'山东省滨州市无棣县海丰街道桃花岭村',flag:1},
        {name:'无棣县泽利农资经营部',zb:[117.623,37.761],code:'农药经许（鲁）37162320070',faren:'冯金波',phone:'13854314141',addr:'无棣县蓝海商城',flag:1},
        {name:'无棣县立明农资经营部',zb:[117.603,37.758],code:'农药经许（鲁）37162320060',faren:'孙玉军',phone:'18954317288',addr:'无棣县棣丰街道杨三里村',flag:1},
        {name:'无棣县森睿电子商务服务中心',zb:[117.678,37.741],code:'农药经许（鲁）37162320125',faren:'杨延辉',phone:'13356243728',addr:'无棣县棣丰街道办事处李白杨村',flag:1},
        {name:'无棣县繁硕农资经营部',zb:[117.611,37.738],code:'农药经许（鲁）37162320102',faren:'袁孟胜',phone:'13562303169',addr:'无棣县棣丰街道袁白杨村',flag:1},
        {name:'无棣县可悦农资批发中心',zb:[117.661,37.738],code:'农药经许（鲁）37162320092',faren:'刘红山',phone:'15154343344',addr:'无棣县棣丰街道袁白杨村',flag:1},
        {name:'无棣县朱立峰农资经营部',zb:[117.715,37.701],code:'农药经许（鲁）37162320119',faren:'朱立峰',phone:'18265789345',addr:'无棣县棣丰街道东袁村328号',flag:1},
        {name:'无棣县绿风植保服务专业合作社',zb:[117.583,37.750],code:'农药经许（鲁）37162320090',faren:'许树立',phone:'18254373268',addr:'无棣县无棣镇工业园荣昌路',flag:1},
        {name:'无棣县金色秋天农资经营部',zb:[117.619,37.738],code:'农药经许（鲁）37162320122',faren:'谭有峰',phone:'13954303009',addr:'无棣县中心大街10号',flag:1},
        {name:'北海新区成辉农资经营部',zb:[117.757,38.005],code:'农药经许（鲁）37162320135',faren:'孟令辉',phone:'13854313229',addr:'山东省滨州市无棣县马山子镇帝赐街村',flag:1},
        {name:'无棣县金然农资门市部',zb:[117.605,37.736],code:'农药经许（鲁）37162320059',faren:'关金然',phone:'13905433022',addr:'无棣县棣新一路',flag:1},
        {name:'无棣县润丰源种子经营部',zb:[117.605,37.771],code:'农药经许（鲁）37162320038',faren:'窦瑞峰',phone:'13561513567',addr:'无棣县棣新一路',flag:1},
        {name:'无棣县金然农资门市部',zb:[117.605,37.736],code:'农药经许（鲁）37162320059',faren:'关金然',phone:'13905433022',addr:'无棣县棣新一路',flag:1},
        {name:'无棣县鑫国光农化服务中心',zb:[117.602,37.760],code:'农药经许（鲁）37162320104',faren:'马井新',phone:'13589723257',addr:'无棣县棣新一路',flag:1},
        {name:'无棣县玺玉农资批发部',zb:[117.603,37.725],code:'农药经许（鲁）37162320134',faren:'曹金霞',phone:'15266733429',addr:'无棣县棣新一路',flag:1},
        {name:'无棣县王震农资经营服务部',zb:[117.603,37.744],code:'农药经许（鲁）37000010040',faren:'安玉会',phone:'13805433676',addr:'无棣县棣新一路22号',flag:1},
        {name:'山东前胡农牧有限公司',addr:'无棣县信阳镇前胡村',code:'（2020）兽药经营证字15324001号',faren:'李玉宝',zb:[117.655,37.820],phone:'13655430777',flag:2},
        {name:'无棣县富玲兽药饲料服务部',addr:'无棣县小泊头镇泊西村',code:'（2021）兽药经营证字15324001号',faren:'刘富玲',zb:[117.564,38.048],phone:'13326281956',flag:2},
        {name:'无棣县小泊头镇龙村畜禽保健中心',addr:'山东省滨州市无棣县小泊头镇政府驻地',code:'（2020）兽药经营证字15324004号',faren:'郭龙村',zb:[117.595,38.052],phone:'1395433395',flag:2},
        {name:'无棣县泽丰兽药经营有限公司',addr:'山东省滨州市无棣县埕口镇东北村66号',code:'（2020）兽药经营证字15324001号',faren:'秦 键',zb:[117.730,38.102],phone:'13589700369',flag:2},
        {name:'无棣青敏兽药有限公司',addr:'山东省滨州市无棣县碣石山镇大山东村',code:'（2020）兽药经营证字15324007号',faren:'周庆民',zb:[117.687,38.015],phone:'13205439252',flag:2},
        {name:'无棣县润之农畜禽服务中心',addr:'无棣县工业园星湖三路',code:'（2020）兽药经营证字15324005号',faren:'王 杰',zb:[117.671,37.726],phone:'13011798088',flag:2},
        {name:'利贞兽药经营部',addr:'无棣县富路大街',code:'（2016）兽药经营证字15324018号',faren:'刘学宁',zb:[117.616,37.733],phone:'13176290458',flag:2},
        {name:'希望畜牧兽药大全',addr:'无棣县富路大街',code:'（2020）兽药经营证字15324006号',faren:'苏清花',zb:[117.623,37.732],phone:'13792283637',flag:2},
        {name:'无棣明方养殖服务有限公司',addr:'山东省滨州市无棣县海丰街道海丰五路南棣新三路东海丰建材城',code:'（2020）兽药经营证字15324002号',faren:'杜桂芳',zb:[117.611,37.733],phone:'13181006166',flag:2},
        {name:'无棣县良景畜禽经营部',addr:'无棣县信阳镇阳城名邸沿街房5号',code:'（2020）兽药经营证字15324003号',faren:'王海英',zb:[117.612,37.803],phone:'18054503607',flag:2},
        {name:'无棣正升饲料有限公司',addr:'无棣县碣石山镇驻地',code:'（2016）兽药经营证字15324016号',faren:'陈世文',zb:[117.686,38.003],phone:'13706373996',flag:2},
        {name:'山东汇杺农牧科技股份有限公司',zb:[117.691,37.724],addr:'山东省滨州市无棣县工业园星湖三路东首',code:'鲁饲证（2017）13100',faren:'张洪昌',phone:'15898898508',flag:3},
        {name:'无棣六和饲料有限公司',zb:[117.694,37.738],addr:'山东省滨州市无棣县工业园星湖三路',code:'鲁饲证（2019）13032',faren:'付志刚',phone:'15153407080',flag:3},
        {name:'无棣瑞兴生物科技有限公司',zb:[117.673,37.734],addr:'山东省滨州市无棣县工业园纬一路1号',code:'鲁饲证（2019）13059',faren:'王维义',phone:'18654397111',flag:3},
        {name:'山东安益生物科技有限公司',zb:[117.706,37.732],addr:'山东省滨州市无棣县棣丰街道星湖三路以南',code:'鲁饲添（2021）H13318、鲁饲预（2021）13419',faren:'刘长亭',phone:'18054382076',flag:3},
        {name:'山东同辉生物科技有限公司',zb:[117.713,37.770],addr:'山东省滨州市无棣县水湾镇路杨工业项目聚集区蔡河路以东清波河以南',code:'鲁饲添（2019）T13121',faren:'刘同辉',phone:'18654636830',flag:3},
        {name:'无棣美龙饲料科技有限公司',zb:[117.731,37.799],addr:'山东省滨州市无棣县水湾镇袁李杨村',code:'鲁饲证（2021）13130',faren:'张皓',phone:'15318999508',flag:3},
        {name:'滨州市林和生物科技有限公司',zb:[117.706,37.822],addr:'山东省滨州市无棣县水湾镇飞龙商贸街66号',code:'鲁饲证（2021）13137',faren:'甄如林',phone:'13854364772',flag:3},
        {name:'滨州市万泰生物科技有限公司',zb:[117.783,37.960],addr:'山东省滨州市无棣县柳堡镇柳堡工业园',code:'鲁饲证（2019）13005',faren:'冯培池',phone:'13705433578',flag:3},
        {name:'山东悦翔生物有限公司',zb:[117.797,37.952],addr:'山东省滨州市无棣县新海工业园',code:'鲁饲证（2019）13046',faren:'吴悦',phone:'15054381999',flag:3},
        {name:'无棣斌杰农牧有限公司',zb:[117.792,38.003],addr:'山东省滨州市无棣县柳堡镇冯王村',code:'鲁饲证（2017）13105',faren:'吴恩平',phone:'18354325777',flag:3},
        {name:'无棣县安牧荣生物科技有限公司',zb:[117.791,37.967],addr:'山东省滨州市无棣县柳堡镇新海工业园',code:'鲁饲证（2017）13051',faren:'付伟端',phone:'18950299038',flag:3},
        {name:'山东兴滨生物科技有限公司',zb:[117.785,37.959],addr:'山东省滨州市无棣县新海工业园',code:'鲁饲证（2018）13044',faren:'杨洪伟',phone:'13854353333',flag:3},
        {name:'滨州市康庆生物有限公司',zb:[117.802,37.964],addr:'山东省滨州市无棣县新海工业园',code:'鲁饲证（2019）13060',faren:'孟金玉',phone:'15254301333',flag:3},
        {name:'山东安聚和生物科技有限公司',zb:[117.782,37.980],addr:'山东省滨州市无棣县柳堡镇张东公路与新海路交叉口北800米路西',code:'鲁饲证（2021）13141',faren:'刘洪基',phone:'13685432225',flag:3},
        {name:'山东花园鱼油科技有限公司',zb:[117.617,37.811],addr:'山东省滨州市无棣县信阳二中以东',code:'鲁饲证（2019）13039',faren:'张瑞义',phone:'13805433738',flag:3},
        {name:'山东前胡农牧有限公司',zb:[117.660,37.823],addr:'山东省滨州市无棣县信阳镇前胡村东100米',code:'鲁饲证（2021）13021',faren:'李玉宝',phone:'13655430777',flag:3},
        {name:'山东波尔莱特饲料有限公司',zb:[117.639,37.807],addr:'山东省滨州市无棣县信阳镇如意村',code:'鲁饲证（2021）13134',faren:'汤伟',phone:'19954355798',flag:3},
        {name:'无棣县潇峻生物科技有限公司',zb:[117.600,37.823],addr:'山东省滨州市无棣县信阳镇大庄东村南1000米',code:'鲁饲证（2020）13128',faren:'吴金燕',phone:'18054395067',flag:3},
        {name:'山东鑫瑞农牧科技有限公司',zb:[117.624,37.810],addr:'山东省滨州市无棣县信阳镇大济路西184道乡南100米',code:'鲁饲证（2020）13121',faren:'鉴升军',phone:'15335431377',flag:3},
        {name:'无棣县兴亚生物科技有限公司',zb:[117.722,38.001],addr:'山东省滨州市无棣县碣石山镇大庄子村村南',code:'鲁饲证（2018）13094鲁饲添（2018）T13078',faren:'张金辉',phone:'18754344666',flag:3},
        {name:'无棣正升饲料有限公司',zb:[117.709,38.010],addr:'山东省滨州市无棣县碣石山镇驻地',code:'鲁饲证（2019）13043',faren:'陈世文',phone:'15054381777',flag:3},
        {name:'无棣天和农牧有限公司',zb:[117.727,38.018],addr:'山东省滨州市无棣县碣石山镇张家码头村',code:'鲁饲证（2018）13109',faren:'张函',phone:'17865105588',flag:3},
        {name:'滨州金华良生物科技有限公司',zb:[117.727,38.005],addr:'山东省滨州市无棣县碣石山镇大庄子东村',code:'鲁饲证（2017）13022',faren:'冯景花',phone:'13695433098',flag:3},
        {name:'无棣兴昌水产科技有限公司',zb:[117.727,38.015],addr:'山东省滨州市无棣县碣石山镇张家码头村（大济路东）',code:'鲁饲证（2017）13102',faren:'杨云昌',phone:'15254337222',flag:3},
        {name:'无棣碣石山镇恒德膨化羽毛粉厂',zb:[117.702,38.000],addr:'山东省滨州市无棣县碣石山镇南新海路西',code:'鲁饲证（2020）13078',faren:'唐福花',phone:'13455763389',flag:3},
        {name:'无棣县通泰生物科技有限公司',zb:[117.621,38.047],addr:'山东省滨州市无棣县小泊头镇泊埕桥东新海路路北',code:'鲁饲证（2021）13058',faren:'孙金明',phone:'13675439588',flag:3},
        {name:'希隆（滨州）饲料添加剂有限公司',zb:[117.621,38.059],addr:'山东省滨州市无棣县小泊头镇孙道门村',code:'鲁饲预（2019）13751',faren:'孙宏强',phone:'13465433597',flag:3},
        {name:'滨州市中力康农牧科技有限公司',zb:[117.573,38.056],addr:'山东省滨州市无棣县小泊头镇北高村村口',code:'鲁饲预（2019）13772',faren:'仝林凤',phone:'15031725006',flag:3},
        {name:'无棣渤海蛋白饲料科技有限公司',zb:[117.592,38.060],addr:'山东省滨州市无棣县小泊头镇工业园',code:'鲁饲证（2019）13047',faren:'贾兆辉',phone:'15065208345',flag:3},
        {name:'无棣质珍牛羊舔砖有限公司',zb:[117.583,38.063],addr:'山东省滨州市无棣县小泊头镇姜家村',code:'鲁饲预（2019）13668',faren:'王连珍',phone:'15954370391',flag:3},
        {name:'滨州市无棣县同明饲料加工厂',zb:[117.598,38.060],addr:'山东省滨州市无棣县小泊头镇开发区18号',code:'鲁饲预（2020）13810',faren:'曹同明',phone:'18265796617',flag:3},
        {name:'滨州宏鑫生物科技有有限公司',zb:[117.607,38.056],addr:'山东省滨州市无棣县小泊头镇工业园马道门村南200米',code:'鲁饲添（2021）T13577',faren:'王灿中',phone:'18177772998',flag:3},
        {name:'滨州久久和牧农牧科技有限公司',zb:[117.642,38.036],addr:'山东省滨州市无棣县小泊头镇邢郑王村东南999米',code:'鲁饲证（2021）13142',faren:'李洪生',phone:'18705490278',flag:3},
        {name:'山东睿展海洋生物科技有限公司',zb:[117.873,38.002],addr:'山东省滨州市无棣县西港经济园区疏港公路北首',code:'鲁饲证（2017）13015',faren:'张金标',phone:'13805433533',flag:3},
        {name:'滨州市辉大蛋白饲料有限公司',zb:[117.824,38.021],addr:'山东省滨州市北海新区马山子镇蔡家村南',code:'鲁饲证（2019）13012',faren:'王胜辉',phone:'13589736999',flag:3},
        {name:'滨州申酉辰饲料有限公司',zb:[117.744,38.029],addr:'山东省滨州市无棣县北海新区马山子镇高井村',code:'鲁饲证（2019）13037',faren:'张传平',phone:'13906493901',flag:3},
        {name:'山东汇泰饲料有限公司',zb:[117.867,38.024],addr:'山东省滨州北海经济开发区原马山子镇政府西侧金盛水产8号楼101室',code:'鲁饲证（2021）13089',faren:'张骏',phone:'18954389999',flag:3},
        {name:'滨州久聚源生物科技有限公司',zb:[117.731,38.026],addr:'山东省滨州市北海经济开发区马山子镇胡道口闸',code:'鲁饲证（2017）13008',faren:'邢玉法',phone:'13561580058',flag:3},
        {name:'金盛海洋科技有限公司',zb:[117.973,38.022],addr:'山东省滨州市北海经济技术开发区北海大街东',code:'鲁饲添（2019）T13014',faren:'张小飞',phone:'18860560827',flag:3},
        {name:'山东省鲁盐集团东方海盐有限公司',zb:[117.887,38.034],addr:'山东省滨州市北海经济开发区马山子镇向阳路52号',code:'鲁饲添（2020）T13013',faren:'吴英滨',phone:'13561583758',flag:3},
        {name:'无棣华有饲料有限公司',zb:[117.606,37.716],addr:'山东省滨州市无棣县海丰街道办事处汪家村南500米路东',code:'鲁饲证（2018）13010',faren:'吴连锴',phone:'18653656886',flag:3},
        {name:'山东全安饲料有限公司',zb:[117.818,37.855],addr:'山东省滨州市无棣县西小王镇北小王村',code:'鲁饲证（2017）13054',faren:'马风树',phone:'17615439111',flag:3},
      ],
      content: '',
      overlay: null,
      searchmodel: '',
      botclass: 'bot2_map',
      drawer: false,
    };
  },
  mounted() {
    this.olInit();
    this.mapOnInit();
    if (this.$route.path == '/tomap'){
      this.botclass = 'bot1_map'
    }
},
  computed: {
    flag1len(){
      return this.datas.filter(item => item.flag == 1).length + 3
    },
    flag2len(){
      return this.datas.filter(item => item.flag == 2).length
    },
    flag3len(){
      return this.datas.filter(item => item.flag == 3).length
    },
  },
  methods: {
    tozb(item){
      this.content.innerHTML = item.name
      this.overlay.setPosition(item.zb);
      this.mapView.setCenter(item.zb);
      this.drawer = false
    },
    searchChange(e){
      if(e == null || e == ''){
        return
      }
      let value = this.datas.filter(el=>el.name==e)
      this.content.innerHTML = value[0].name
      this.overlay.setPosition(value[0].zb);
      this.mapView.setCenter(value[0].zb);
    },
    mapOnInit() {
      this.map.on("singleclick", (e) => {
        // 获取点击的标注
        let features = this.map.forEachFeatureAtPixel(e.pixel, (feature) => {
          return feature;
        });
        if (features && features.values_ && features.values_.features) {
          let currentFeature = features.values_.features;
          let str = ''
          for (let index = 0; index < currentFeature.length; index++) {
            var data = currentFeature[index].values_.data;
            if (typeof data == "string") {
              if (index == 0){
                str = data
              }else{
                str = str + '<br>' + data
              }
            }else{
              let tmp = '<p>单位：' + data.name + '<br/>法人：' + data.faren + '<br/>电话：' + data.phone + '<br/>证号：' + data.code + '<br/>地址：' + data.addr + '</p>'
              if (index == 0){
                str = tmp
              }else{
                str += tmp
              }
            }
          }
          this.content.innerHTML = str
          this.overlay.setPosition(e.coordinate);
        }
      });
    },
    createLabel(data) {
      let marker = new Feature({
        geometry: new Point(data.zb), // 标签位置坐标
        // data: data.name,
        data,
      });
      return marker;
    },
    olInit() {
      let alllayers = [
        new TileLayer({
          // title: "天地图路网",
          source: new XYZ({
            url:
              "https://t{0-7}.tianditu.gov.cn/DataServer?T=vec_w&x={x}&y={y}&l={z}&tk=f16e54e604a0c45510c916cc9fab51d8",
          }),
        }),
        new TileLayer({
          // title: "天地图路网注记",
          source: new XYZ({
            url:
              "https://t{0-7}.tianditu.gov.cn/DataServer?T=cva_w&x={x}&y={y}&l={z}&tk=f16e54e604a0c45510c916cc9fab51d8",
          }),
        }),
      ];

      const container = document.getElementById('popup');
      this.content = document.getElementById('popup-content');
      const closer = document.getElementById('popup-closer');
      this.overlay = new Overlay({
        element: container,
        autoPan: true,
        autoPanAnimation: {
          duration: 250,
        },
      });
      let _this = this
      closer.onclick = function () {
        _this.overlay.setPosition(undefined);
        closer.blur();
        return false;
      };

      this.mapView = new View({
        center: [117.614, 37.770],
        projection: 'EPSG:4326',
        zoom: 13,
      });
      this.map = new Map({
        target: 'map',
        layers: alllayers,
        overlays: [this.overlay],
        view: this.mapView,
      });
      let markers = []
      this.datas.forEach(data => {
        markers.push(this.createLabel(data))
      });
      let markerSources = new VectorSource({
        features: markers,
      });
      let clusterMarkers = new Cluster({
        // 创建聚合标注对象
        distance: 25, // 设置聚合标注的距离
        source: markerSources,
      });
      let vectorLayer = new VectorLayer({
        source: clusterMarkers,
        style: function (feature) {
          let size = feature.get("features").length;
          let fillcolor = '#F44336'
          if (size > 1){
            fillcolor = '#2196F3'
          } else if (size == 1) {
            const flag = feature.get("features")[0].values_.data.flag
            if (flag == 2){
              fillcolor = '#3F51B5'
            } else if (flag == 3){
              fillcolor = '#9C27B0'
            }
          }
          return new Style({
            image: new CircleStyle({
              radius: 10,
              stroke: new Stroke({
                color: "#fff",
              }),
              fill: new Fill({
                color: fillcolor,
              }),
            }),
            text: new Text({
              text: size.toString(),
              fill: new Fill({
                color: "#fff",
              }),
            }),
          });
        },
      });
      this.map.addLayer(vectorLayer);
    },
  },
};
</script>
<style>
  .container{
    padding: 0;
    margin: 0;
    max-width: 100%;
  }
  .bot_map{
    position: absolute;
    right: 0;
    padding: 10px;
    font-weight: bold;
  }
  .bot1_map{
    bottom: 60px;
  }
  .bot2_map{
    bottom: 0;
  }
  .bot_map .flag1 {
    color: #F44336;
    margin-right: 20px;
  }
  .bot_map .flag2 {
    color: #3F51B5;
    margin-right: 20px;
  }
  .bot_map .flag3 {
    color: #9C27B0;
  }
  .top_map{
    position: absolute;
    top: 0;
    right: 0;
  }
  .ol-popup {
    position: absolute;
    background-color: white;
    box-shadow: 0 1px 4px rgba(0,0,0,0.2);
    padding: 15px;
    padding-top: 20px;
    border-radius: 10px;
    border: 1px solid #cccccc;
    bottom: 12px;
    left: -50px;
    min-width: 350px;
  }
  .ol-popup:after, .ol-popup:before {
    top: 100%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  .ol-popup:after {
    border-top-color: white;
    border-width: 10px;
    left: 48px;
    margin-left: -10px;
  }
  .ol-popup:before {
    border-top-color: #cccccc;
    border-width: 11px;
    left: 48px;
    margin-left: -11px;
  }
  .ol-popup-closer {
    text-decoration: none;
    position: absolute;
    top: 2px;
    right: 8px;
  }
  .ol-popup-closer:after {
    content: "✖";
  }
</style>